import config from '@/config';
import filters from '@/filters';
import mixins from '@/mixins';
import widgets from '@/widgets';
import '@/styles/app.less';

export default function init(Vue) {
  // 远程js组件
  Vue.component('remote-script', {
    props: {
      src: {
        type: String,
        required: true,
      },
    },
    render: function (createElement) {
      return createElement('script', {
        attrs: {
          type: 'text/javascript',
          src: this.src,
        },
      });
    },
  });

  // 远程css组件
  Vue.component('remote-stylesheet', {
    props: {
      href: {
        type: String,
        required: true,
      },
    },
    render: function (createElement) {
      return createElement('link', {
        attrs: {
          rel: 'stylesheet',
          href: this.href,
        },
      });
    },
  });

  // 注册自定义组件
  widgets.install(Vue, config);

  // 注册过滤器
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
  });

  // 混入
  Vue.mixin(mixins);
}
